import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.hico.dev';
const DEFAULT_IMAGE = `${SITE_URL}/images/forestsupport.webp`;

interface SeoProps {
  title: string;
  description: string;
  path: string;
  image?: string;
}

const Seo: React.FC<SeoProps> = ({ title, description, path, image }) => {
  const url = `${SITE_URL}${path}`;
  const ogImage = image ? `${SITE_URL}${image}` : DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="HICO" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Seo;
